import { t } from '@lingui/core/macro'
import Link from '@mui/material/Link'
import { AccountFieldManager, AuthFieldType } from '../components'
import { AccountType } from '../types'

const SNAPCHAT_CLIENT_ID_KEY = 'client_id'
const SNAPCHAT_CLIENT_SECRET_KEY = 'client_secret'

interface SnapchatProps {
  newConnection: boolean
  updatedAccount: AccountType
  setRequiredFieldMissing: (fieldsMissing: boolean) => void
  setUpdatedAccount: (updatedAccount: AccountType) => void
}

export const Snapchat = ({
  updatedAccount,
  setUpdatedAccount,
  setRequiredFieldMissing,
  newConnection,
}: SnapchatProps) => {
  const clientId = updatedAccount.metadata.client_id
  const clientSecret = updatedAccount.metadata.client_secret

  const SnapchatAdsFields: AuthFieldType[] = [
    {
      fieldValue: clientId,
      fieldKey: SNAPCHAT_CLIENT_ID_KEY,
      fieldLabel: t`Client ID`,
      description: t`The Client ID and Client Secret are associated with your `,
      fieldDescriptionElement: (
        <Link
          href="https://businesshelp.snapchat.com/s/article/api-apply"
          target="_blank"
          rel="noreferrer"
          underline="hover"
        >
          {t`Snapchat business OAuth app.`}
        </Link>
      ),
    },
    {
      fieldValue: clientSecret,
      fieldKey: SNAPCHAT_CLIENT_SECRET_KEY,
      fieldLabel: t`Client secret`,
    },
  ]

  return (
    <AccountFieldManager
      newConnection={newConnection}
      updatedAccount={updatedAccount}
      setUpdatedAccount={setUpdatedAccount}
      accountFields={SnapchatAdsFields}
      setRequiredFieldsMissing={setRequiredFieldMissing}
    />
  )
}
